import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Mixin from 'components/common/Mixin'
import Rating from 'components/common/Rating'
import { BIG_O_LOGO_IMAGE_SRC } from './constants'

const ReviewBlock = ({
  Rating: ratingCount,
  ReviewMessage,
  ReviewerName,
  LocationName,
  TotalNumberOfReviewsForLocation,
  formattedDate
}) =>
  <Wrapper itemProp="Rating" itemScope itemType="http://schema.org/Rating">
    <Icon>
      <Img src={ BIG_O_LOGO_IMAGE_SRC } alt="Survey" />
    </Icon>
    <Summary>
      <Rating
        inline
        small
        reviewName={ LocationName }
        ratingCount={ ratingCount }
        reviewsCount={ TotalNumberOfReviewsForLocation }
        ratingMax={ 5 }
        showStarsOnly={ !!TotalNumberOfReviewsForLocation } />
      <meta itemProp="datePublished" content={ formattedDate } />
      <Date>{ formattedDate }</Date>
      <Info>
        <Reviewer itemProp="author" itemScope itemType="http://schema.org/Person">
          <span itemProp="name">{ ReviewerName }</span>
        </Reviewer>
      </Info>
    </Summary>
    <Comment itemProp="reviewBody">{ ReviewMessage }</Comment>
  </Wrapper>

export default ReviewBlock

ReviewBlock.propTypes = {
  formattedDate: PropTypes.string,
  LocationName: PropTypes.string,
  Rating: PropTypes.number,
  ReviewerName: PropTypes.string,
  ReviewMessage: PropTypes.string,
  TotalNumberOfReviewsForLocation: PropTypes.number
}

const Wrapper = styled.div`
  padding-bottom: 20px;
`

const Img = styled.img`
  width: 40px;
  height: 40px;
  border-radius: 4px;
`

const Icon = styled.div`
  float: left;
  margin-top: 2px;
  width: 50px;
`

const Summary = styled.div`
  display: block;
  width: 100%;
`

const Date = styled.div`
  display: inline-block;
  position: absolute;
  right: 10px;
  color: #37556e;
  font-size: 12px;
  line-height: 26px;
`

const Info = styled.div`
  color: #37556e;
  font-size: 12px;
  margin-top: 5px;
  ${Mixin.ellipsis()}
`

const Reviewer = styled.span`
  color: #37556e;
  white-space: nowrap;
`

const Comment = styled.div`
  padding-top: 7px;
`
